import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorNotificationService } from '../services/error-notification.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService {

  constructor(private router: Router, private errorSvc: ErrorNotificationService ) { }

  handleError(error: any): void {
    this.errorSvc.notify("We caan complete di request.  Try one next time or sen we a e-mail to di support team!" +  `<p>${error}</p>`);

    this.showGlobalError();
  }

  showGlobalError() {
    this.router.navigate(['/error']);
  }
}
